module.exports = __webpack_public_path__ + "img/students3_new.bcf8121e.png";